import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "download_link",
  "use": "download_link-usage",
  "viewBox": "0 0 443.7 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 443.7 512\" id=\"download_link\"><path d=\"M238.9 0v238.9c38.7-25.5 68-53.4 102.4-54.6-59.4 58-90.4 133.8-119.5 225.3-21.4-83.5-62.3-160.7-119.5-225.3 37.3 4 61.1 28.8 102.4 54.6V0h34.2zM34.1 477.9H0V375.5h34.1v102.4zM0 512v-34.1h443.7V512H0zm443.7-34.1h-34.1V375.5h34.1v102.4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./sv_cms/static/assets/images/icons/download_link.svg
// module id = 296
// module chunks = 6